<template>
     <side-bar :background-color="sidebarBackground" short-title="SchoolDock" title="SchoolDock" v-if="$store.state.auth.user_status_id==2">       
         <template slot="links">
          <sidebar-item :link="{name: 'Dashboard', icon: 'ni ni-tv-2 text-primary', path: '/dashboard'
            }" />
          <sidebar-item :link="{name: 'Member', icon: 'fa fa-users text-blue', path: '/member'}"/>
          <sidebar-item :link="{name: 'Family', icon: 'ni ni-badge text-blue', path: '/family'}"/>
          <sidebar-item :link="{name: 'Department', icon: 'ni ni-app text-blue', path: '/department'}" />  
           <sidebar-item :link="{name: 'Event', icon: 'fa fa-calendar text-blue', path: '/event'}" />  
          <sidebar-item :link="{name: 'Notifcation', icon: 'fa fa-info text-blue', path: '/notification'}" />  
           <sidebar-item :link="{name: 'Message', icon: 'fa fa-tv text-blue', path: '/message'}" />     
        </template>
      </side-bar>
</template>
<script>
export default {
     data() {
      return {
        sidebarBackground: 'vue' //vue|blue|orange|green|red|primary
      };
    },
}
</script>